import React from 'react';
import { Popover } from '@tencent/tea-component';
import { useAppSelector } from '@store/hooks';
import { useTranslation } from 'react-i18next';
import './HeaderInfo.scss';
import { getMeetingInfo } from '@store/meeting/meeting.slice';
import { atou } from '@utils/string';
import { getUserList } from '@store/user/user.slice';
import { WeMeetClient } from '@tencent/wemeet-websdk-next';
import { execCommandCopy } from '@utils/browser';
import { openToast } from '@component/toast';
import { formatMeetingCode } from '@utils/helper/meeting';

const HeaderInfo: React.FC = () => {
  const { t } = useTranslation();
  const meeting = useAppSelector(getMeetingInfo);
  const userlist = useAppSelector(getUserList);
  const host = userlist.find((user) => WeMeetClient.utils.isHost(user));

  const copyInfo = (str: string, toastText: string) => {
    execCommandCopy(str);
    openToast(toastText);
  };
  return (
    <Popover
      trigger="click"
      placement="bottom"
      overlay={
        <>
          <div>{atou(meeting.subject)}</div>
          <div className="header-info-popover__item">
            <div className="header-info-popover__item__label">{t('会议号：')}</div>
            <div className="header-info-popover__item__value">{formatMeetingCode(meeting.meeting_code)}</div>
            <i
              className="header-info-popover__item__icon"
              onClick={() => copyInfo(meeting.meeting_code, t('会议号复制成功'))}
            />
          </div>
          <div className="header-info-popover__item">
            <div className="header-info-popover__item__label">{t('主持人：')}</div>
            <div className="header-info-popover__item__value">{host?.nickname ?? ''}</div>
          </div>
          {meeting.password && (
            <div className="header-info-popover__item">
              <div className="header-info-popover__item__label">{t('会议密码：')}</div>
              <div className="header-info-popover__item__value">
                {WeMeetClient.utils.decodeB64ThenUtf8(meeting.password)}
              </div>
            </div>
          )}

          <div className="header-info-popover__item">
            <div className="header-info-popover__item__label">{t('邀请链接：')}</div>
            <div className="header-info-popover__item__value">{atou(meeting.url)}</div>
            <i
              className="header-info-popover__item__icon"
              onClick={() => copyInfo(atou(meeting.url), t('会议邀请链接复制成功'))}
            />
          </div>
        </>
      }
      overlayClassName="header-info-popover"
    >
      <div className="header-info" />
    </Popover>
  );
};

export default React.memo(HeaderInfo);
